module.exports = __webpack_public_path__ + "static/article3-41b55ecaa7b46ff0678ccf3611da9736.png";